module.exports = __webpack_public_path__ + "img/JLPT學院.f1671cdb.png";